function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { utils as utils_exports, PSVError, AbstractAdapter, events as events_exports, EquirectangularAdapter, CONSTANTS as constants_exports } from '../core/index.module.js';
import { MathUtils, Frustum, Matrix4, Vector3, ImageLoader, SphereGeometry, Mesh, MeshBasicMaterial, CanvasTexture } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.EquirectangularTilesAdapter 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */

// ../shared/Queue.ts
var Task = /*#__PURE__*/function () {
  function Task(id, priority, fn) {
    _classCallCheck(this, Task);
    this.id = id;
    this.priority = priority;
    this.fn = fn;
    this.status = 1 /* PENDING */;
  }
  _createClass(Task, [{
    key: "start",
    value: function start() {
      var _this = this;
      this.status = 2 /* RUNNING */;
      return this.fn(this).then(function () {
        _this.status = 4 /* DONE */;
      }, function () {
        _this.status = 5 /* ERROR */;
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.status = 3 /* CANCELLED */;
    }
  }, {
    key: "isCancelled",
    value: function isCancelled() {
      return this.status === 3 /* CANCELLED */;
    }
  }]);
  return Task;
}();
var Queue = /*#__PURE__*/function () {
  function Queue() {
    var concurency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    _classCallCheck(this, Queue);
    this.concurency = concurency;
    this.runningTasks = {};
    this.tasks = {};
  }
  _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(task) {
      this.tasks[task.id] = task;
    }
  }, {
    key: "clear",
    value: function clear() {
      Object.values(this.tasks).forEach(function (task) {
        return task.cancel();
      });
      this.tasks = {};
      this.runningTasks = {};
    }
  }, {
    key: "setPriority",
    value: function setPriority(taskId, priority) {
      var task = this.tasks[taskId];
      if (task) {
        task.priority = priority;
        if (task.status === 0 /* DISABLED */) {
          task.status = 1 /* PENDING */;
        }
      }
    }
  }, {
    key: "disableAllTasks",
    value: function disableAllTasks() {
      Object.values(this.tasks).forEach(function (task) {
        task.status = 0 /* DISABLED */;
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;
      if (Object.keys(this.runningTasks).length >= this.concurency) {
        return;
      }
      var nextTask = Object.values(this.tasks).filter(function (task) {
        return task.status === 1;
      } /* PENDING */).sort(function (a, b) {
        return b.priority - a.priority;
      }).pop();
      if (nextTask) {
        this.runningTasks[nextTask.id] = true;
        nextTask.start().then(function () {
          if (!nextTask.isCancelled()) {
            delete _this2.tasks[nextTask.id];
            delete _this2.runningTasks[nextTask.id];
            _this2.start();
          }
        });
        this.start();
      }
    }
  }]);
  return Queue;
}();
function buildErrorMaterial(width, height) {
  var canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.fillStyle = "#333";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.font = "".concat(canvas.width / 5, "px serif");
  ctx.fillStyle = "#a22";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("\u26A0", canvas.width / 2, canvas.height / 2);
  var texture = new CanvasTexture(canvas);
  return new MeshBasicMaterial({
    map: texture
  });
}

// src/EquirectangularTilesAdapter.ts
var NB_VERTICES_BY_FACE = 6;
var NB_VERTICES_BY_SMALL_FACE = 3;
var ATTR_UV = "uv";
var ATTR_ORIGINAL_UV = "originaluv";
var ATTR_POSITION = "position";
function tileId(tile) {
  return "".concat(tile.col, "x").concat(tile.row);
}
var getConfig = utils_exports.getConfigParser({
  resolution: 64,
  showErrorTile: true,
  baseBlur: true,
  blur: false
}, {
  resolution: function resolution(_resolution) {
    if (!_resolution || !MathUtils.isPowerOfTwo(_resolution)) {
      throw new PSVError("EquirectangularTilesAdapter resolution must be power of two");
    }
    return _resolution;
  }
});
var frustum = new Frustum();
var projScreenMatrix = new Matrix4();
var vertexPosition = new Vector3();
var EquirectangularTilesAdapter = /*#__PURE__*/function (_AbstractAdapter) {
  _inherits(EquirectangularTilesAdapter, _AbstractAdapter);
  var _super = _createSuper(EquirectangularTilesAdapter);
  function EquirectangularTilesAdapter(viewer, config) {
    var _this3;
    _classCallCheck(this, EquirectangularTilesAdapter);
    _this3 = _super.call(this, viewer);
    _this3.state = {
      colSize: 0,
      rowSize: 0,
      facesByCol: 0,
      facesByRow: 0,
      tiles: {},
      geom: null,
      materials: [],
      errorMaterial: null
    };
    _this3.queue = new Queue();
    _this3.config = getConfig(config);
    _this3.viewer.config.useXmpData = false;
    _this3.SPHERE_SEGMENTS = _this3.config.resolution;
    _this3.SPHERE_HORIZONTAL_SEGMENTS = _this3.SPHERE_SEGMENTS / 2;
    _this3.NB_VERTICES = 2 * _this3.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + (_this3.SPHERE_HORIZONTAL_SEGMENTS - 2) * _this3.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
    _this3.NB_GROUPS = _this3.SPHERE_SEGMENTS * _this3.SPHERE_HORIZONTAL_SEGMENTS;
    if (_this3.viewer.config.requestHeaders) {
      utils_exports.logWarn('EquirectangularTilesAdapter fallbacks to file loader because "requestHeaders" where provided. Consider removing "requestHeaders" if you experience performances issues.');
    } else {
      _this3.loader = new ImageLoader();
      if (_this3.viewer.config.withCredentials) {
        _this3.loader.setWithCredentials(true);
      }
    }
    _this3.viewer.addEventListener(events_exports.PositionUpdatedEvent.type, _assertThisInitialized(_this3));
    _this3.viewer.addEventListener(events_exports.ZoomUpdatedEvent.type, _assertThisInitialized(_this3));
    return _this3;
  }
  _createClass(EquirectangularTilesAdapter, [{
    key: "destroy",
    value: function destroy() {
      var _this$state$errorMate, _this$state$errorMate2, _this$state$errorMate3;
      this.viewer.addEventListener(events_exports.PositionUpdatedEvent.type, this);
      this.viewer.addEventListener(events_exports.ZoomUpdatedEvent.type, this);
      this.__cleanup();
      (_this$state$errorMate = this.state.errorMaterial) === null || _this$state$errorMate === void 0 ? void 0 : (_this$state$errorMate2 = _this$state$errorMate.map) === null || _this$state$errorMate2 === void 0 ? void 0 : _this$state$errorMate2.dispose();
      (_this$state$errorMate3 = this.state.errorMaterial) === null || _this$state$errorMate3 === void 0 ? void 0 : _this$state$errorMate3.dispose();
      delete this.state.geom;
      delete this.state.errorMaterial;
      _get(_getPrototypeOf(EquirectangularTilesAdapter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports.PositionUpdatedEvent || e instanceof events_exports.ZoomUpdatedEvent) {
        this.__refresh();
      }
    }
  }, {
    key: "supportsTransition",
    value: function supportsTransition(panorama) {
      return !!panorama.baseUrl;
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload(panorama) {
      return !!panorama.baseUrl;
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(panorama) {
      if (_typeof(panorama) !== "object" || !panorama.width || !panorama.cols || !panorama.rows || !panorama.tileUrl) {
        return Promise.reject(new PSVError("Invalid panorama configuration, are you using the right adapter?"));
      }
      if (panorama.cols > this.SPHERE_SEGMENTS) {
        return Promise.reject(new PSVError("Panorama cols must not be greater than ".concat(this.SPHERE_SEGMENTS, ".")));
      }
      if (panorama.rows > this.SPHERE_HORIZONTAL_SEGMENTS) {
        return Promise.reject(new PSVError("Panorama rows must not be greater than ".concat(this.SPHERE_HORIZONTAL_SEGMENTS, ".")));
      }
      if (!MathUtils.isPowerOfTwo(panorama.cols) || !MathUtils.isPowerOfTwo(panorama.rows)) {
        return Promise.reject(new PSVError("Panorama cols and rows must be powers of 2."));
      }
      var panoData = {
        fullWidth: panorama.width,
        fullHeight: panorama.width / 2,
        croppedWidth: panorama.width,
        croppedHeight: panorama.width / 2,
        croppedX: 0,
        croppedY: 0,
        poseHeading: 0,
        posePitch: 0,
        poseRoll: 0
      };
      if (panorama.baseUrl) {
        if (!this.adapter) {
          this.adapter = new EquirectangularAdapter(this.viewer, {
            blur: this.config.baseBlur
          });
        }
        return this.adapter.loadTexture(panorama.baseUrl, panorama.basePanoData).then(function (textureData) {
          return {
            panorama: panorama,
            texture: textureData.texture,
            panoData: panoData
          };
        });
      } else {
        return Promise.resolve({
          panorama: panorama,
          panoData: panoData,
          texture: null
        });
      }
    }
  }, {
    key: "createMesh",
    value: function createMesh() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var geometry = new SphereGeometry(constants_exports.SPHERE_RADIUS * scale, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1).toNonIndexed();
      geometry.clearGroups();
      var i = 0;
      var k = 0;
      for (; i < this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE; i += NB_VERTICES_BY_SMALL_FACE) {
        geometry.addGroup(i, NB_VERTICES_BY_SMALL_FACE, k++);
      }
      for (; i < this.NB_VERTICES - this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE; i += NB_VERTICES_BY_FACE) {
        geometry.addGroup(i, NB_VERTICES_BY_FACE, k++);
      }
      for (; i < this.NB_VERTICES; i += NB_VERTICES_BY_SMALL_FACE) {
        geometry.addGroup(i, NB_VERTICES_BY_SMALL_FACE, k++);
      }
      geometry.setAttribute(ATTR_ORIGINAL_UV, geometry.getAttribute(ATTR_UV).clone());
      return new Mesh(geometry, []);
    }
  }, {
    key: "setTexture",
    value: function setTexture(mesh, textureData, transition) {
      var _this4 = this;
      var panorama = textureData.panorama,
        texture = textureData.texture;
      if (transition) {
        this.__setTexture(mesh, texture);
        return;
      }
      this.__cleanup();
      this.__setTexture(mesh, texture);
      this.state.materials = mesh.material;
      this.state.geom = mesh.geometry;
      this.state.geom.setAttribute(ATTR_UV, this.state.geom.getAttribute(ATTR_ORIGINAL_UV).clone());
      this.state.colSize = panorama.width / panorama.cols;
      this.state.rowSize = panorama.width / 2 / panorama.rows;
      this.state.facesByCol = this.SPHERE_SEGMENTS / panorama.cols;
      this.state.facesByRow = this.SPHERE_HORIZONTAL_SEGMENTS / panorama.rows;
      setTimeout(function () {
        return _this4.__refresh(true);
      });
    }
  }, {
    key: "__setTexture",
    value: function __setTexture(mesh, texture) {
      var material;
      if (texture) {
        material = new MeshBasicMaterial({
          map: texture
        });
      } else {
        material = new MeshBasicMaterial({
          opacity: 0,
          transparent: true
        });
      }
      for (var i = 0; i < this.NB_GROUPS; i++) {
        mesh.material.push(material);
      }
    }
  }, {
    key: "setTextureOpacity",
    value: function setTextureOpacity(mesh, opacity) {
      mesh.material[0].opacity = opacity;
      mesh.material[0].transparent = opacity < 1;
    }
  }, {
    key: "setOverlay",
    value: function setOverlay() {
      throw new PSVError("EquirectangularTilesAdapter does not support overlay");
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(textureData) {
      var _textureData$texture;
      (_textureData$texture = textureData.texture) === null || _textureData$texture === void 0 ? void 0 : _textureData$texture.dispose();
    }
  }, {
    key: "__refresh",
    value: function __refresh() {
      var _this5 = this;
      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.state.geom) {
        return;
      }
      var camera = this.viewer.renderer.camera;
      camera.updateMatrixWorld();
      projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
      frustum.setFromProjectionMatrix(projScreenMatrix);
      var panorama = this.viewer.config.panorama;
      var verticesPosition = this.state.geom.getAttribute(ATTR_POSITION);
      var tilesToLoad = [];
      for (var col = 0; col < panorama.cols; col++) {
        for (var row = 0; row < panorama.rows; row++) {
          var verticesIndex = [];
          if (row === 0) {
            var v0 = this.state.facesByRow === 1 ? col * this.state.facesByCol * NB_VERTICES_BY_SMALL_FACE + 1 : this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + (this.state.facesByRow - 2) * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + col * this.state.facesByCol * NB_VERTICES_BY_FACE + 4;
            var v1 = this.state.facesByRow === 1 ? v0 + (this.state.facesByCol - 1) * NB_VERTICES_BY_SMALL_FACE + 1 : v0 + (this.state.facesByCol - 1) * NB_VERTICES_BY_FACE + 1;
            var v2 = 0;
            verticesIndex.push(v0, v1, v2);
            if (this.state.facesByCol >= this.SPHERE_SEGMENTS / 8) {
              var v4 = v0 + this.state.facesByCol / 2 * NB_VERTICES_BY_FACE;
              verticesIndex.push(v4);
            }
            if (this.state.facesByRow >= this.SPHERE_HORIZONTAL_SEGMENTS / 4) {
              var v6 = v0 - this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              var v7 = v1 - this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              verticesIndex.push(v6, v7);
            }
          } else if (row === panorama.rows - 1) {
            var _v = this.state.facesByRow === 1 ? -this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + row * this.state.facesByRow * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + col * this.state.facesByCol * NB_VERTICES_BY_SMALL_FACE + 1 : -this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + row * this.state.facesByRow * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + col * this.state.facesByCol * NB_VERTICES_BY_FACE + 1;
            var _v2 = this.state.facesByRow === 1 ? _v + (this.state.facesByCol - 1) * NB_VERTICES_BY_SMALL_FACE - 1 : _v + (this.state.facesByCol - 1) * NB_VERTICES_BY_FACE - 1;
            var _v3 = this.NB_VERTICES - 1;
            verticesIndex.push(_v, _v2, _v3);
            if (this.state.facesByCol >= this.SPHERE_SEGMENTS / 8) {
              var _v4 = _v + this.state.facesByCol / 2 * NB_VERTICES_BY_FACE;
              verticesIndex.push(_v4);
            }
            if (this.state.facesByRow >= this.SPHERE_HORIZONTAL_SEGMENTS / 4) {
              var _v5 = _v + this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              var _v6 = _v2 + this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              verticesIndex.push(_v5, _v6);
            }
          } else {
            var _v7 = -this.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + row * this.state.facesByRow * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + col * this.state.facesByCol * NB_VERTICES_BY_FACE + 1;
            var _v8 = _v7 + (this.state.facesByRow - 1) * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + 3;
            var _v9 = _v8 + (this.state.facesByCol - 1) * NB_VERTICES_BY_FACE + 1;
            var v3 = _v7 + (this.state.facesByCol - 1) * NB_VERTICES_BY_FACE - 1;
            verticesIndex.push(_v7, _v8, _v9, v3);
            if (this.state.facesByCol >= this.SPHERE_SEGMENTS / 8) {
              var _v10 = _v7 + this.state.facesByCol / 2 * NB_VERTICES_BY_FACE;
              var v5 = _v8 + this.state.facesByCol / 2 * NB_VERTICES_BY_FACE;
              verticesIndex.push(_v10, v5);
            }
            if (this.state.facesByRow >= this.SPHERE_HORIZONTAL_SEGMENTS / 4) {
              var _v11 = _v7 + this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              var _v12 = v3 + this.state.facesByRow / 2 * this.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE;
              verticesIndex.push(_v11, _v12);
              if (this.state.facesByCol >= this.SPHERE_SEGMENTS / 8) {
                var v8 = _v11 + this.state.facesByCol / 2 * NB_VERTICES_BY_FACE;
                verticesIndex.push(v8);
              }
            }
          }
          var vertexVisible = verticesIndex.some(function (vertexIdx) {
            vertexPosition.set(verticesPosition.getX(vertexIdx), verticesPosition.getY(vertexIdx), verticesPosition.getZ(vertexIdx));
            vertexPosition.applyEuler(_this5.viewer.renderer.sphereCorrection);
            return frustum.containsPoint(vertexPosition);
          });
          if (vertexVisible) {
            var angle = vertexPosition.angleTo(this.viewer.state.direction);
            if (row === 0 || row === panorama.rows - 1) {
              angle *= 2;
            }
            tilesToLoad.push({
              col: col,
              row: row,
              angle: angle
            });
          }
        }
      }
      this.__loadTiles(tilesToLoad);
    }
  }, {
    key: "__loadTiles",
    value: function __loadTiles(tiles) {
      var _this6 = this;
      this.queue.disableAllTasks();
      tiles.forEach(function (tile) {
        var id = tileId(tile);
        if (_this6.state.tiles[id]) {
          _this6.queue.setPriority(id, tile.angle);
        } else {
          _this6.state.tiles[id] = true;
          _this6.queue.enqueue(new Task(id, tile.angle, function (task) {
            return _this6.__loadTile(tile, task);
          }));
        }
      });
      this.queue.start();
    }
  }, {
    key: "__loadTile",
    value: function __loadTile(tile, task) {
      var _this7 = this;
      var panorama = this.viewer.config.panorama;
      var url = panorama.tileUrl(tile.col, tile.row);
      return this.__loadImage(url).then(function (image) {
        if (!task.isCancelled()) {
          var material = new MeshBasicMaterial({
            map: utils_exports.createTexture(image)
          });
          _this7.__swapMaterial(tile.col, tile.row, material);
          _this7.viewer.needsUpdate();
        }
      })["catch"](function () {
        if (!task.isCancelled() && _this7.config.showErrorTile) {
          if (!_this7.state.errorMaterial) {
            _this7.state.errorMaterial = buildErrorMaterial(_this7.state.colSize, _this7.state.rowSize);
          }
          _this7.__swapMaterial(tile.col, tile.row, _this7.state.errorMaterial);
          _this7.viewer.needsUpdate();
        }
      });
    }
  }, {
    key: "__loadImage",
    value: function __loadImage(url) {
      var _this8 = this;
      if (this.loader) {
        return new Promise(function (resolve, reject) {
          _this8.loader.load(url, resolve, void 0, reject);
        });
      } else {
        return this.viewer.textureLoader.loadImage(url);
      }
    }
  }, {
    key: "__swapMaterial",
    value: function __swapMaterial(col, row, material) {
      var _this9 = this;
      var uvs = this.state.geom.getAttribute(ATTR_UV);
      for (var c = 0; c < this.state.facesByCol; c++) {
        var _loop = function _loop() {
          var faceCol = col * _this9.state.facesByCol + c;
          var faceRow = row * _this9.state.facesByRow + r;
          var isFirstRow = faceRow === 0;
          var isLastRow = faceRow === _this9.SPHERE_HORIZONTAL_SEGMENTS - 1;
          var firstVertex;
          if (isFirstRow) {
            firstVertex = faceCol * NB_VERTICES_BY_SMALL_FACE;
          } else if (isLastRow) {
            firstVertex = _this9.NB_VERTICES - _this9.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + faceCol * NB_VERTICES_BY_SMALL_FACE;
          } else {
            firstVertex = _this9.SPHERE_SEGMENTS * NB_VERTICES_BY_SMALL_FACE + (faceRow - 1) * _this9.SPHERE_SEGMENTS * NB_VERTICES_BY_FACE + faceCol * NB_VERTICES_BY_FACE;
          }
          var matIndex = _this9.state.geom.groups.find(function (g) {
            return g.start === firstVertex;
          }).materialIndex;
          _this9.state.materials[matIndex] = material;
          var top = 1 - r / _this9.state.facesByRow;
          var bottom = 1 - (r + 1) / _this9.state.facesByRow;
          var left = c / _this9.state.facesByCol;
          var right = (c + 1) / _this9.state.facesByCol;
          if (isFirstRow) {
            uvs.setXY(firstVertex, (left + right) / 2, top);
            uvs.setXY(firstVertex + 1, left, bottom);
            uvs.setXY(firstVertex + 2, right, bottom);
          } else if (isLastRow) {
            uvs.setXY(firstVertex, right, top);
            uvs.setXY(firstVertex + 1, left, top);
            uvs.setXY(firstVertex + 2, (left + right) / 2, bottom);
          } else {
            uvs.setXY(firstVertex, right, top);
            uvs.setXY(firstVertex + 1, left, top);
            uvs.setXY(firstVertex + 2, right, bottom);
            uvs.setXY(firstVertex + 3, left, top);
            uvs.setXY(firstVertex + 4, left, bottom);
            uvs.setXY(firstVertex + 5, right, bottom);
          }
        };
        for (var r = 0; r < this.state.facesByRow; r++) {
          _loop();
        }
      }
      uvs.needsUpdate = true;
    }
  }, {
    key: "__cleanup",
    value: function __cleanup() {
      this.queue.clear();
      this.state.tiles = {};
      this.state.materials.forEach(function (mat) {
        var _mat$map;
        mat === null || mat === void 0 ? void 0 : (_mat$map = mat.map) === null || _mat$map === void 0 ? void 0 : _mat$map.dispose();
        mat === null || mat === void 0 ? void 0 : mat.dispose();
      });
      this.state.materials.length = 0;
    }
  }]);
  return EquirectangularTilesAdapter;
}(AbstractAdapter);
EquirectangularTilesAdapter.id = "equirectangular-tiles";
EquirectangularTilesAdapter.supportsDownload = false;
EquirectangularTilesAdapter.supportsOverlay = false;
export { EquirectangularTilesAdapter };
//# sourceMappingURL=index.module.js.map
